import { TextInput } from '@any-ui-react/core';
import type { UseFormRegisterReturn } from 'react-hook-form';

interface AllocationPercentageInputProps {
  registration: UseFormRegisterReturn;
  disabled?: boolean;
  error?: string;
}

export const AllocationPercentageInput = ({ registration, disabled, error }: AllocationPercentageInputProps) => (
  <TextInput
    {...registration}
    className="tabular-nums min-w-20 max-w-20"
    disabled={disabled}
    error={error}
    max={100}
    min={0}
    rightSection="%"
    type="number"
  />
);
